/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import ContentHub from 'ui/components/cards/ContentHub.vue';
import ContentHubMarketing from 'ui/pages/ContentHubMarketing.vue';
import CreateWorkspaceButton from 'ui/components/CreateWorkspaceButton.vue';
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';

// Utils
import { isEmpty } from 'lodash';

/**
 * This component is the main ContentHubsList page controller.
 *
 * @category ui.pages
 * @exports ContentHubsList
 * @component
 */
const __vue_script__ = {
    name: 'ContentHubsList',

    components: { ContentHub, ContentHubMarketing, CreateWorkspaceButton, SearchBar },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        const orgs = this.$services.user.getOrgsByFeatureFlag('content_hubs_enabled');
        const canAccess = Boolean(orgs.length);
        return {
            canAccess,
            canCreate: Boolean(this.$services.user.getOrgsUserIsAllowedToCreateContentHubFor().length),
            contentHubs: {},
            hasContentHub: false,
            loading: true,
            searchTerm: '',
            visibleContentHubs: {}
        };
    },

    computed: {
        /**
         * Returns true if there is at least one content hub to display
         * @returns {Boolean}
         */
        hasResults() {
            // A result can only be present in latest if he's all. So we only check all.
            return isEmpty(this.searchTerm) || !isEmpty(this.visibleContentHubs.all);
        },

        /**
         * Returns true if there is at least one latest content hub.
         * @returns {Boolean}
         */
        hasLatest() {
            return this.visibleContentHubs.latest && !isEmpty(this.visibleContentHubs.latest);
        }
    },

    watch: {
        searchTerm() {
            this.filterSearch();
        }
    },

    async created() {
        try {
            if (this.canAccess) {
                const latestContentHubIds = this.$services.contentHub
                    .getLastAccessed(this.$services.storage)
                    // Only get last 8 accessed content hubs
                    .slice(0, 8);

                this.contentHubs = await this.$services.contentHub.getUserContentHubs(latestContentHubIds);
                this.hasContentHub = this.contentHubs.all && !isEmpty(this.contentHubs.all);
                this.resetSearch();
            }
        } catch (error) {
            console.error('[ContentHubsList] An error occurred while loading user Content Hubs');
            this.$services.crashReporting.captureException(error);
            this.hasContentHub = false;
        } finally {
            this.loading = false;
        }
    },

    methods: {

        /**
         * Reset the filtered search result to the inital dataset
         */
        resetSearch() {
            this.visibleContentHubs = { ...this.contentHubs };
        },

        /**
         * Filter the events by the search input
         */
        filterSearch() {
            if (isEmpty(this.searchTerm)) {
                this.resetSearch();
                return;
            }

            const locale = this.$i18n.locale;
            const searchTerms = this.searchTerm.toLocaleLowerCase(locale).trim().split(' ');

            for (const [stage, contentHubs] of Object.entries(this.contentHubs)) {
                this.visibleContentHubs[stage] = contentHubs.filter(ch => {
                    const lookupString = (`${ch.name}`).toLocaleLowerCase(locale);
                    return searchTerms.every(term => lookupString.includes(term));
                });
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "loader",
    { staticClass: "inner-page", attrs: { status: _vm.loading } },
    [
      _vm.canAccess
        ? _c(
            "section",
            { staticClass: "page-content content-hubs-page" },
            [
              _vm.hasContentHub
                ? [
                    _c("h1", [
                      _vm._v(_vm._s(_vm.$t("content_hubs.content_hubs"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "search" },
                      [
                        _vm.canCreate
                          ? _c("create-workspace-button", {
                              staticClass: "create",
                              attrs: {
                                "modal-classes": "small",
                                "button-key": "content_hubs.create",
                                "modal-type": "content_hub",
                              },
                            })
                          : _vm._e(),
                        _c("search-bar", {
                          attrs: { results: _vm.hasResults },
                          model: {
                            value: _vm.searchTerm,
                            callback: function ($$v) {
                              _vm.searchTerm = $$v
                            },
                            expression: "searchTerm",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.hasResults
                      ? [
                          _vm.hasLatest
                            ? _c("div", { staticClass: "section-list" }, [
                                _c("h4", { staticClass: "separator" }, [
                                  _vm._v(_vm._s(_vm.$t("content_hubs.latest"))),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "listing-grid" },
                                  _vm._l(
                                    _vm.visibleContentHubs.latest,
                                    function (contentHub) {
                                      return _c("content-hub", {
                                        attrs: { "content-hub": contentHub },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "section-list" }, [
                            _c("h4", { staticClass: "separator" }, [
                              _vm._v(_vm._s(_vm.$t("content_hubs.all"))),
                            ]),
                            _c(
                              "div",
                              { staticClass: "listing-grid" },
                              _vm._l(
                                _vm.visibleContentHubs.all,
                                function (contentHub) {
                                  return _c("content-hub", {
                                    attrs: { "content-hub": contentHub },
                                  })
                                }
                              ),
                              1
                            ),
                          ]),
                        ]
                      : _vm._e(),
                  ]
                : _c(
                    "div",
                    { staticClass: "no-data" },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "lazy",
                            rawName: "v-lazy",
                            value: _vm.$utils.assets.imagePath(
                              "content-hub-start.svg"
                            ),
                            expression:
                              "$utils.assets.imagePath('content-hub-start.svg')",
                          },
                        ],
                        attrs: { alt: _vm.$t("content_hubs.welcome") },
                      }),
                      _c("h1", { staticClass: "welcome" }, [
                        _vm._v(_vm._s(_vm.$t("content_hubs.welcome"))),
                      ]),
                      _c("p", { staticClass: "message" }, [
                        _vm._v(_vm._s(_vm.$t("content_hubs.empty"))),
                      ]),
                      _vm.canCreate
                        ? _c("create-workspace-button", {
                            attrs: {
                              "modal-classes": "small",
                              "button-key": "content_hubs.create",
                              "modal-type": "content_hub",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
            ],
            2
          )
        : _c("content-hub-marketing", { attrs: { params: _vm.params } }),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/pages/ContentHubsList.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__